<template>
    <s-top-bar v-if="ribbon" v-bind="{ ...ribbon, menu }" />
</template>

<script>
import { mapState } from 'vuex';
import { LOCALE_DEFAULT } from '@model/const/locales.ts';
import STopBar from './top-bar.vue';

const STORE_SLICE_NAME = 's-main-header';

export default {
    name: 'STopBarContainer',
    components: { STopBar },
    props: {
        ribbons: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            ribbon: null,
        };
    },
    computed: {
        ...mapState({
            menu: (state) => state.slices.items?.[STORE_SLICE_NAME]?.menuExtra || [],
        }),
    },
    async serverPrefetch() {
        const locale = this.$store.state.geolocation.finalLocale || LOCALE_DEFAULT;
        await this.$store.dispatch('slices/getSyncedData', { slice: STORE_SLICE_NAME, locale });
    },
    mounted() {
        this.ribbon = this.ribbons[Math.floor(Math.random() * this.ribbons.length)];
    },
};
</script>
